import * as React from "react";

const StepperBackArrow = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="48"
      height="48"
      viewBox="0 0 48 48"
      fill="none"
    >
      <path
        d="M27 28.59L22.42 24L27 19.41L25.59 18L19.59 24L25.59 30L27 28.59Z"
        fill="#3E4240"
      />
      <rect
        x="47"
        y="47"
        width="46"
        height="46"
        rx="23"
        transform="rotate(-180 47 47)"
        stroke="#11734A"
        strokeOpacity="0.4"
        strokeWidth="2"
      />
    </svg>
  );
};
export default StepperBackArrow;

export const StepperBackArrowV2 = ({ color = "#292B2A" }) => {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M10.5307 12.4696C10.6715 12.6105 10.7507 12.8016 10.7507 13.0008C10.7507 13.2001 10.6715 13.3912 10.5307 13.5321C10.3898 13.673 10.1987 13.7521 9.9994 13.7521C9.80014 13.7521 9.60905 13.673 9.46815 13.5321L4.46815 8.53206C4.39823 8.46239 4.34275 8.37959 4.3049 8.28843C4.26704 8.19726 4.24756 8.09952 4.24756 8.00081C4.24756 7.9021 4.26704 7.80436 4.3049 7.7132C4.34275 7.62204 4.39823 7.53924 4.46815 7.46956L9.46815 2.46956C9.60905 2.32867 9.80014 2.24951 9.9994 2.24951C10.1987 2.24951 10.3898 2.32867 10.5307 2.46956C10.6715 2.61046 10.7507 2.80156 10.7507 3.00081C10.7507 3.20007 10.6715 3.39117 10.5307 3.53206L6.06252 8.00019L10.5307 12.4696Z" fill={color} />
    </svg>
  );
};

export const StepperBackArrowNew = () => {
  return <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="47" y="47" width="46" height="46" rx="23" transform="rotate(-180 47 47)" stroke="#30A35E" stroke-opacity="0.8" strokeWidth="2" />
    <g clip-path="url(#clip0_1169_37636)">
      <path d="M27 28.59L22.42 24L27 19.41L25.59 18L19.59 24L25.59 30L27 28.59Z" fill="#30A35E" />
    </g>
    <defs>
      <clipPath id="clip0_1169_37636">
        <rect width="24" height="24" fill="white" transform="matrix(-1 0 0 -1 36 36)" />
      </clipPath>
    </defs>
  </svg>
}
